import React, { useEffect, useState } from 'react'


import {
  Grid,
  Picker,
  Input,
  Form,
  Button,
  Row,
  SelectForm,
  AutoCompleteSearchTerm,
  FakeChartCard
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useException, useLoading, useModal, useTabs, useDebounce } from 'hooks'
import moment from 'moment'
import { UseWorkAccidentOccurrence } from 'pages/GST/Registers/WorkAccidentOccurrence/context'
import { useFormContext } from 'react-hook-form'
import { If, Then, Else } from 'react-if'
import { IResponseTypes } from 'services/core/genericEntityGST'
import { CentrosServices, WorkAccidentOccurrenceServices, EmpresasServices, ISearchEmpresaResponse, ISearchCentroPlantaResponse, SupplierServices } from 'services/GST/WorkAccidentOccurrence'
import { SPACING, FORMAT } from 'utils'

import { IForm } from '../../types'

interface IAddNewProps {
  justRead?: boolean
}

const AddNewForm: React.FC<IAddNewProps> = ({
  justRead,
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
    reset,
    setValue
  } = useFormContext<IForm>()

  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { getException, createCustomException } = useException()
  const { handleSetIdOcorrenciaSelecionado } = UseWorkAccidentOccurrence()
  const { handleAddTab, handleRemoveTab, rawTabs, handleChangeTab } = useTabs()

  const [centros, setCentros] = useState<ISearchCentroPlantaResponse[]>([])
  const [empresas, setEmpresas] = useState<ISearchEmpresaResponse[]>([])
  const [loadingCentros, setLoadingCentros] = useState<boolean>(false)
  const [loadingEmpresas, setLoadingEmpresas] = useState<boolean>(false)

  const cdCnpjPassaporte = watch('cdCnpjPassaporte')
  const qtCaf = watch('qtCaf') ?? 0
  const qtSaf = watch('qtSaf') ?? 0
  const qtPs = watch('qtPs') ?? 0
  const qtDanoMaterial = watch('qtDanoMaterial') ?? 0
  const qtAtdAmbiental = watch('qtAtendimentoAmb') ?? 0
  const qtTrajCaf = watch('qtTrajetoCaf') ?? 0
  const qtTrajSaf = watch('qtTrajetoSaf') ?? 0
  const qtTrajPs = watch('qtTrajetoPs') ?? 0
  const qtIncendio = watch('qtIncendio') ?? 0


  function arred(d, casas) {
    const aux = Math.pow(10, casas)
    return Math.floor(d * aux) / aux
  }

  const qtDiasPerdidos = watch('qtDiasPerdidos') ?? 0
  const totalCafSafPs = watch('qtTotalCafSafSp') ?? 0
  const totalOcorrencias = watch('qtTotalOcorrencias') ?? 0
  const hht = String(watch('hht'))
  const taxaFrequenciaCAFSAF = String(arred(watch('taxaFrequenciaCAFSAF'), 2))
  const taxaFrequenciaCAF = String(arred(watch('taxaFrequenciaCAF'), 2))
  const taxaGravidade = String(arred(watch('taxaGravidade'), 2))


  const handleSubmitForm = (form: IForm) => {
    setLoading('loading')

    WorkAccidentOccurrenceServices()
      .createOcorrencia({
        cdCnpjPassaporte: FORMAT.unMask(form.cdCnpjPassaporte),
        cdTipoFornecedor: Number(form.cdTipoFornecedor),
        idCentro: Number(form.idCentro),
        nmEmpresa: form.nmEmpresa,
        nmFornecedor: form.nmFornecedor,
        nuCompetencia: Number(moment(form.nuCompetencia).format('YYYYMM')),
        qtAtendimentoAmb: Number(form.qtAtendimentoAmb),
        qtCaf: Number(form.qtCaf),
        qtDanoMaterial: Number(form.qtDanoMaterial),
        qtDiasPerdidos: Number(form.qtDiasPerdidos),
        qtIncendio: Number(form.qtIncendio),
        qtPs: Number(form.qtPs),
        qtSaf: Number(form.qtSaf),
        qtTrajetoCaf: Number(form.qtTrajetoCaf),
        qtTrajetoPs: Number(form.qtTrajetoPs),
        qtTrajetoSaf: Number(form.qtTrajetoSaf)
      })
      .then(response => {
        if (response?.status !== 200 || response?.data?.tipo === IResponseTypes['alert']) {
          const { tipo, detalhe, mensagem, } = response?.data

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        setLoading('idle')
        handleChangeTab(null, 0)
        showModal({
          hideButtonCancel: true,
          message: 'Ocorrência foi salva com sucesso!',
          txtButtonConfirm: 'OK',
          type: 'success',
        })
      })
      .catch((e: Error) => {
        setLoading('idle')
        const error = getException(e)

        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error',
        })
      })
  }

  const handleSearchEmpresas = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setLoadingEmpresas(true)

    const inputText = event.target.value.includes('%') ? event.target.value : `%${event.target.value}%`

    EmpresasServices()
      .searchEmpresa({
        hasDinamicSearch: true,
        nmEmpresa: inputText,
      })
      .then(response => {
        if (response?.status !== 200 || response?.data?.tipo === IResponseTypes['alert']) {
          const { tipo, detalhe, mensagem, } = response?.data

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        setEmpresas([])
        setEmpresas(response?.data?.entity)
        setLoadingEmpresas(false)
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoadingCentros(false)
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error',
        })
      })
  }

  const handleSearchCentro = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setLoadingCentros(true)

    const inputText = event.target.value.includes('%') ? event.target.value : `%${event.target.value}%`

    CentrosServices()
      .searchCentroPlanta({
        nmCentroPlanta: inputText,
      })
      .then((response) => {
        if (response?.status !== 200 || response?.data?.tipo === IResponseTypes['alert']) {
          const { tipo, detalhe, mensagem, } = response?.data

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        setCentros([])
        setCentros(response?.data?.entity)
        setLoadingCentros(false)
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoadingCentros(false)
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error',
        })
      })
  }

  const handleVoltarNavegacao = () => {
    handleSetIdOcorrenciaSelecionado(0)
    handleAddTab({
      createAndNavigateToNewTab: false,
      tabName: "Adicionar Novo"
    })

    handleRemoveTab({
      removeAndNavigateToPreviousDefaultTab: true,
      tabName: rawTabs[1].name
    })
  }

  const getSupplierByCnpj = (cnpj: string) => {
    if (cnpj?.length > 0) {
      setLoading('loading')

      SupplierServices()
        .getByCnpj(FORMAT.unMask(cnpj))
        .then(({ data }) => {

          setValue('nmFornecedor', data.nmFornecedor)
          setLoading('idle')
        })
        .catch((e: Error) => {
          const error = getException(e)
          setValue('nmFornecedor', '')
          setValue('cdCnpjPassaporte', '')

          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Fornecedor não encontrado!',
            txtButtonConfirm: 'OK',
            type: error.tipo || 'error',
          })
        })
    }
  }

  const handleResetForm = () => {
    reset()
  }

  useEffect(() => {
    setValue(
      'qtTotalCafSafSp',
      [Number(qtCaf), Number(qtSaf), Number(qtPs)]
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0))

    setValue(
      'qtTotalOcorrencias',
      [
        Number(qtCaf), Number(qtSaf), Number(qtPs), Number(qtDanoMaterial),
        Number(qtAtdAmbiental), Number(qtTrajCaf), Number(qtTrajSaf),
        Number(qtTrajPs), Number(qtIncendio)
      ].reduce((previousValue, currentValue) => previousValue + currentValue, 0)
    )
  }, [
    qtCaf, qtSaf, qtPs,
    qtDanoMaterial, qtAtdAmbiental, qtTrajCaf,
    qtTrajSaf, qtTrajPs, qtIncendio
  ])

  return (
    <>
      <Row justifyContent="center">
        <Grid
          gridCols="2fr 2fr 2fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <FakeChartCard title="Número de Dias perdidos" content={qtDiasPerdidos} />
          <FakeChartCard
            title="Quantidade Total (CAF + SAF + PS)"
            content={totalCafSafPs}
          />
          <FakeChartCard title="Total de Ocorrências" content={totalOcorrencias} />
        </Grid>
      </Row>
      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing10}
        padding={SPACING.spacing20}
      >
        <Grid
          gridCols="1fr 1fr 1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Picker
            label="Mês/Ano"
            formValue="nuCompetencia"
            type={'monthAndYear'}
            control={control}
            disabled={justRead}
          />
          <If condition={justRead}>
            <Then>
              <Input
                control={control}
                errors={errors}
                label="Empresa"
                placeholder="Empresa"
                formValue="nmEmpresa"
                disabled
              />
            </Then>
            <Else>
              <AutoCompleteSearchTerm
                noFilter
                errors={errors}
                options={empresas.length > 0 ? empresas : []}
                label="Empresa"
                placeholder="Empresa"
                onChangeText={useDebounce(handleSearchEmpresas, 600) || null}
                control={control}
                loading={loadingEmpresas}
                formValue="nmEmpresa"
                optionLabel="nmEmpresa"
                optionValue="nmEmpresa"
              />
            </Else>
          </If>
          <If condition={justRead}>
            <Then>
              <Input
                control={control}
                errors={errors}
                label="Centro"
                placeholder="Centro"
                formValue="nmCentro"
                disabled
              />
            </Then>
            <Else>
              <AutoCompleteSearchTerm
                noFilter
                errors={errors}
                options={centros.length > 0 ? centros : []}
                label="Centro"
                placeholder="Centro"
                onChangeText={useDebounce(handleSearchCentro, 600) || null}
                control={control}
                loading={loadingCentros}
                formValue="idCentro"
                optionLabel="nmCentroPlanta"
                optionValue="idCentroPlanta"
              />
            </Else>
          </If>
        </Grid>
        <Grid
          gridCols="1fr 1fr 1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <SelectForm
            control={control}
            errors={errors}
            label="Tipo"
            formValue="cdTipoFornecedor"
            listOptions={[
              { label: "Pessoa Física", value: '0' },
              { label: "Pessoa Jurídica", value: '1' },
              { label: "Pessoa Estrangeira", value: '2' },
            ]}
            clearSelect={true}
            disabled={justRead}
          />
          <Input
            control={control}
            errors={errors}
            label="CPF/CNPJ/Cód.Fornecedor"
            placeholder="Nº"
            formValue="cdCnpjPassaporte"
            mask={
              isNaN(parseInt(cdCnpjPassaporte))
                ? ['#############']
                : ['###.###.###-##', '##.###.###/####-##']
            }
            inputIcon={<MagnifyingGlassIcon />}
            onClickIcon={() => getSupplierByCnpj(cdCnpjPassaporte)}
            disabled={justRead}
          />
          <Input
            control={control}
            errors={errors}
            label="Fornecedor"
            placeholder="Fornecedor"
            formValue="nmFornecedor"
            disabled
          />
        </Grid>
        <Grid
          gridCols="1fr 1fr 1fr 1fr 1fr 1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="CAF"
            placeholder="Qtd"
            formValue="qtCaf"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="SAF"
            placeholder="Qtd"
            formValue="qtSaf"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="PS"
            placeholder="Qtd."
            formValue="qtPs"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Dano Material"
            placeholder="Qtd."
            formValue="qtDanoMaterial"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Atend. Amb."
            placeholder="Qtd."
            formValue="qtAtendimentoAmb"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Trajeto CAF"
            placeholder="Qtd."
            formValue="qtTrajetoCaf"
            disabled={justRead}
          />
        </Grid>
        <Grid
          gridCols="1fr 1fr 1fr 1fr 1fr 1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Trajeto SAF"
            placeholder="Qtd"
            formValue="qtTrajetoSaf"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Trajeto PS"
            placeholder="Qtd"
            formValue="qtTrajetoPs"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Incêndio"
            placeholder="Qtd."
            formValue="qtIncendio"
            disabled={justRead}
          />
          <Input
            mask={['##########']}
            control={control}
            errors={errors}
            label="Dias Perdidos"
            placeholder="Qtd."
            formValue="qtDiasPerdidos"
            disabled={justRead}
          />
          <Input
            control={control}
            errors={errors}
            label="Total ( CAF + SAF + PS )"
            placeholder="Qtd."
            formValue="qtTotalCafSafSp"
            disabled
          />
          <Input
            control={control}
            errors={errors}
            label="Total de Ocorrências "
            placeholder="Qtd."
            formValue="qtTotalOcorrencias"
            disabled
          />
        </Grid>
        <If condition={justRead}>
          <Grid
            gridCols="1fr 1fr 1fr 1fr 1fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <Input
              errors={errors}
              label="HHT"
              value={hht}
              disabled
            />
            <Input
              errors={errors}
              label="Taxa de Frequência(CAF + SAF)"
              value={taxaFrequenciaCAFSAF}
              disabled
            />
            <Input
              errors={errors}
              label="Taxa de Frequência(CAF)"
              value={taxaFrequenciaCAF}
              disabled
            />
            <Input
              errors={errors}
              label="Taxa de Gravidade"
              value={taxaGravidade}
              disabled
            />
          </Grid>
        </If>
        <div style={{ height: SPACING.spacing20 }}></div>
        {
          justRead ?
            <Row justifyContent="flex-end">
              <Button
                variantButton="text"
                text="VOLTAR"
                width={'max-content'}
                onClick={handleVoltarNavegacao}
                marginRight={SPACING.spacing20}
              />
            </Row>
            : <Row justifyContent="flex-end">
              <Button
                variantButton="text"
                text="LIMPAR"
                width={'max-content'}
                onClick={handleResetForm}
                marginRight={SPACING.spacing20}
              />
              <Button type="submit" text="SALVAR" />
            </Row>
        }
      </Form>
    </>
  )
}

export default AddNewForm
